<template>
  <svg xmlns="http://www.w3.org/2000/svg" class="icon-vector demo-motion" :class="{ active: active }" viewBox="0 0 60 60">
    <defs>
      <mask :id="uuid + '-circ'">
        <path d="M-8,6h29.3c-2.4,6.7-2.4,14.3,0,21c0.8,2.1,1.8,4.1,2.6,6.2c2.5,6.8,2.2,14.6-0.6,21.2H-8V6z"
          :ref="uuid + '-mask-circ'"
          fill="#fff"/>
      </mask>
      <mask :id="uuid + '-line'">
        <circle id="circ-blk" cx="30" cy="30" r="16" stroke="#fff" stroke-width="3"/>
        <path d="M28.6,54.5c2.9-6.7,3.1-14.4,0.6-21.2c-0.8-2.1-1.8-4.1-2.6-6.2c-2.5-6.7-2.5-14.3,0-21h-2.8 c-2.4,6.7-2.4,14.3,0,21c0.8,2.1,1.8,4.1,2.6,6.2c2.5,6.8,2.2,14.6-0.6,21.2H28.6z"
          :ref="uuid + '-mask-line'"
          fill="#000"/>
      </mask>
    </defs>

    <circle
      id="circ-gray"
      cx="30"
      cy="30"
      r="16"
      fill="none"
      stroke-width="2.5"
      :stroke="fill"
      :opacity="opacity"
      :mask="'url(#' + uuid + '-line)'"/>

    <circle
      id="circ-blk"
      cx="30"
      cy="30"
      r="16"
      fill="none"
      stroke-width="2.5"
      :stroke="fill"
      :mask="'url(#' + uuid + '-circ)'"/>

    <path d="M22.8,6c-2.4,6.7-2.4,14.3,0,21c0.8,2.1,1.8,4.1,2.6,6.2c2.5,6.8,2.2,14.6-0.6,21.2"
      :ref="uuid + '-line'"
      fill="none"
      stroke-width="2.5"
      :stroke="fill"/>
  </svg>
</template>

<script>
import { TweenMax, Elastic } from 'gsap'

export default {
  name: 'motion-icon',
  props: {
    complete: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    },
    isButton: {
      type: Boolean,
      default: false
    },
    white: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      activeTween: undefined,
      tweenTargets: []
    }
  },
  watch: {
    active () {
      if ( this.isButton ) {
        if ( this.active ) {
          this.animateIcon()
        } else {
          if ( this.activeTween ) {
            this.activeTween.pause()
            TweenMax.to( this.tweenTargets, 1, {
              x: 0,
              ease: Elastic.easeInOut
            } )
          }
        }
      }
    }
  },
  computed: {
    opacity () {
      return this.complete ? 1 : 0.25
    },
    fill () {
      return this.white ? '#fff' : '#1F1F1F'
    }
  },
  methods: {
    initTween () {
      this.tweenTargets = [
        this.$refs[this.uuid + '-mask-circ'],
        this.$refs[this.uuid + '-mask-line'],
        this.$refs[this.uuid + '-line']
      ]
      TweenMax.set( this.tweenTargets[0], { x: 1 } )
      this.activeTween = TweenMax.to( this.tweenTargets, 1.5, {
        paused: true,
        x: 10,
        repeat: -1,
        yoyo: true,
        ease: Elastic.easeInOut
      } )
      this.animateIcon()
    },
    animateIcon () {
      if ( this.active && this.activeTween.paused() ) {
        this.activeTween.restart()
      }
    }
  },
  mounted () {
    if ( this.isButton ) {
      this.$nextTick( () => {
        this.initTween()
      } )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/svg/MotionIcon.vue